/**
 * 单独模块的公共方法
 */
let moduleCommon = {

    /**
     * 窗口大小监听方法
     */
    setResizeListener:function(){
        if(!document.addEventListener) return;     
        let resizeFunction = function() {
            let clientWidth = document.documentElement.clientWidth;
            if(!clientWidth) return;
            document.documentElement.style.fontSize = 50 * (clientWidth / 375) + 'px';
        };
        let resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.removeEventListener(resizeEvent, resizeFunction, false);
        document.removeEventListener('DOMContentLoaded', resizeFunction, false);
        window.addEventListener(resizeEvent, resizeFunction, false);
        document.addEventListener('DOMContentLoaded', resizeFunction, false);
    }







}

export default moduleCommon;